export default "__VITE_ASSET__c3cc31a8__"